import { getPromoterId } from '../data/user/getPromoterId.ts';
import { useMe } from './data/auth.ts';
import { useDirectusCollectionDetail } from './data/useDirectusCollectionDetail.ts';

export const useLoggedInUser = () => {
  const user = useMe();
  const promoter = useDirectusCollectionDetail('promoters', getPromoterId(user.data));

  return { user, promoter };
};
